import React from 'react';
import { connect } from 'react-redux';
import { priceState } from '../../store';
import PropTypes from 'prop-types';
import { translate } from '../../services';

const PricePropertyComponent = ( { product, property, prices } ) => {
  if ( !product ) {
    return null;
  }
  if ( !prices[product.name] ) {
    return null;
  }
  if( property.toLowerCase().startsWith( 'priceunit' ) ) {
    const priceUnit = Math.trunc( prices[product.name][property] ).toString() || '-'
    const unitOfMeasure = prices[product.name]['unit'] || '-'
    return <span>{ translate( 'Price per {priceunit} {tr:unitofmeasure}', { priceunit: priceUnit, unitofmeasure: unitOfMeasure } ) }</span>
  }  const value = prices[product.name][property] || '-';
  return <span>{ value }</span>;
};

PricePropertyComponent.propTypes = {
  product: PropTypes.shape( {} ).isRequired,
  property: PropTypes.string.isRequired
};

export const PriceProperty = connect( priceState )( PricePropertyComponent );